import { InningSummary } from '@/app/libs/match/types'
import { getInningsSuffix } from '@/shared/utils'

export default function InningsProgression({
  inningsProgression
}: {
  inningsProgression: InningSummary[]
}) {
  return (
    <>
      <p className="text-lg font-bold text-textOffWhite mb-3">Innings Progression</p>
      {inningsProgression.map((inning, index: number) => {
        const isEven = index % 2 === 0
        if (!inning?.aSummaryGraph?.length) return null
        return (
          <div key={inning.nInningNumber} className="mb-6">
            <div className="text-subSectionText mb-4">
              {getInningsSuffix(inning.nInningNumber)} Inning
            </div>
            {inning?.aSummaryGraph?.map(data => {
              return (
                <div
                  key={data.sTitle}
                  className="w-full mx-auto flex items-center max-w-[704px] gap-4 mb-4"
                >
                  <span className="w-8 whitespace-nowrap">{data?.sTitle}</span>
                  <div
                    className="grid w-full"
                    style={{
                      gridTemplateColumns: `repeat(${data?.aWickets?.length}, 1fr)`
                    }}
                  >
                    {data.aWickets.length > 1 ? (
                      data.aWickets.map((value: any, index: number) => {
                        const isLast = index === data.aWickets.length - 1
                        return (
                          <div
                            key={index}
                            className={`bg-[#F4686F] relative h-2.5 ${index === 0 ? 'rounded-l-full' : ''} ${
                              isLast ? 'rounded-r-full' : ''
                            } ${isEven ? 'bg-[#F4686F]' : 'bg-[#878B8E]'}`}
                          >
                            {value?.nWickets > 0 ? (
                              <span
                                className={`text-white text-center text-xs absolute top-1/2 -translate-y-1/2 h-6 min-w-6 rounded-full bg-lossBg border-[3px] border-[#F4686F] ${isLast ? 'right-0' : index === 0 ? 'left-0' : 'left-1/2 -translate-x-1/2'}`}
                              >
                                {value?.nWickets > 1 ? (
                                  <span className="px-1">{value?.nWickets}W</span>
                                ) : (
                                  'W'
                                )}
                              </span>
                            ) : null}
                          </div>
                        )
                      })
                    ) : (
                      <>
                        {data.aWickets[0].nWickets > 0 ? (
                          <span
                            className={`text-white text-center text-xs h-6 w-6 min-w-6 rounded-full bg-lossBg border-[3px] border-[#F4686F] left-0`}
                          >
                            {data.aWickets[0].nWickets > 1 ? (
                              <span className="px-1">{data.aWickets[0].nWickets}W</span>
                            ) : (
                              'W'
                            )}
                          </span>
                        ) : null}
                      </>
                    )}
                  </div>
                  <span className="w-16 whitespace-nowrap">{data?.nRuns} Runs</span>
                </div>
              )
            })}
          </div>
        )
      })}
    </>
  )
}
